import {Component, Input, OnInit} from '@angular/core';
export interface IForWhomItem {
  src: string;
  m_src: string;
  label: string;
  alt: string;
  link: string;
}
@Component({
  selector: 'app-for-whoom-item',
  templateUrl: './for-whoom-item.component.html',
  styleUrls: ['./for-whoom-item.component.scss']
})
export class ForWhoomItemComponent implements OnInit {

  @Input() data: IForWhomItem;
  constructor() { }

  ngOnInit(): void {
  }

}
